define('lib/jquery/jquery-ui-patches',['require','jquery-ui'],function (require) {

  require('jquery-ui');

  // The check below is necessary for the signup page only, where we load the GTM and common-ui module scripts.
  // Because of an issue in the GTM script loading, the datepicker from the jQuery UI script is undefined.
  // This is a workaround to make sure that GTM tracking works and error in the console is not thrown.
  // In all other pages, the datepicker is defined.
  if ($.datepicker) {

    // Monkey path for this issue, which is being fixed in upcoming 1.11 release:
    // Andreas on Feb. 5, 2015: Unfortunately this bug is still open as of jquery-ui 1.11.2
    // http://bugs.jqueryui.com/ticket/8737
    $.datepicker._findPos = function (obj) {
      var inst = this._getInst(obj);
      var isRTL = this._get(inst, 'isRTL');
      while (obj && (obj.type == 'hidden' || obj.nodeType != 1 || $.expr.filters.hidden(obj))) {
        obj = obj[isRTL ? 'previousSibling' : 'nextSibling'] || obj.parentNode;
      }
      var position = $(obj).offset();
      return [position.left, position.top];
    };
  }
});

